<template>
  <h1 class="" v-if="courses.length > 0">Meus Cursos</h1>
  <div class="video_class mb-4">
    <div class="row gy-4 mt-0" v-for="grid in videoGrid">
      <div
        class="col-md-6 col-lg-6 video"
        v-for="course in courses"
        :key="course.id"
        :id="course.id"
      >
        <a :href="'/curso/' + course.id">
          <div
            class="card"
            :class="{ complete: course.completedClasses === course.totalClasses }"
          >
            <span class="check-icon"><i class="fa fa-check-circle" /></span>

            <div class="video_img_container">
              <img class="video_img" :src="getCourseThumbnailURL(course)" alt="" />
              <span class="tag">{{ progress(course) }}% concluído</span>
            </div>
            <div class="card-body">
              <h4>{{ course.title }}</h4>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["courses"],
  data() {
    return {};
  },
  computed: {
    videoGrid() {
      return [
        [
          this.courses
        ],
      ];
    },
  },
  methods: {
    progress(course) {
      return ((course.completedClasses / course.totalClasses) * 100).toFixed(0);
    },
  },
};
</script>
